//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"AngularTolerance",1,0],[0,"BaseSurface",1,"Body",0],[0,"BoundarySection",1,"Section",0],[0,"ControlSurface",1,"Body",0],[0,"Direction",1,"Direction",0],[0,"DistanceTolerance",1,0],[0,"Height",1,0],[0,"OperatorControlType",1,0],[0,"OperatorOperationType",1,0],[0,"OperatorOutputType",1,0],[0,"OperatorTransitionType",1,0],[0,"PointInFormingRegion",1,"NXObject",0],[0,"ReverseNormal",1,0],[0,"ShapeControl",1,0],[0,"StretchDirection",1,"Direction",0]],[[[],"InitData",{},0,0],[["faces"],"SetTargetFaces",{},1,0],[[],"SetCenterPoint",{},0,0],[[],"SetDefaultDirection",{},0,0],[["numfaces"],"GetTargetFaces",{R_:{faces:"NXObject[]"}},0,0]],[]];
SPLM.Features.OvercrownBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.OvercrownBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.OvercrownBuilder.OperationType = Object.freeze({
    "Overcrown" : "Overcrown", "Stretch" : "Stretch", "Offset" : "Offset"});

SPLM.Features.OvercrownBuilder.ControlType = Object.freeze({
    "ByFunction" : "ByFunction", "BySurface" : "BySurface"});

SPLM.Features.OvercrownBuilder.OutputType = Object.freeze({
    "Sheet" : "Sheet", "Solid" : "Solid"});

SPLM.Features.OvercrownBuilder.TransitionType = Object.freeze({
    "Curve1" : "Curve1", "Curve2" : "Curve2", "LawCurve" : "LawCurve"});

export default SPLM;